import axios from 'axios';
import { resolveTimezone } from '../constants/timezones';

// Add interceptor to include Accept-Language and X-Timezone headers in all requests
axios.interceptors.request.use((config) => {
  const language = localStorage.getItem('language') || 'en';
  const acceptLanguage = language === 'en' ? 'en' : 'es_MX';
  config.headers['Accept-Language'] = acceptLanguage;

  // Resolved here rather than read raw: a stale or unsupported saved value
  // must still produce a zone the backend accepts.
  config.headers['X-Timezone'] = resolveTimezone(localStorage.getItem('timezone'));

  return config;
}, (error) => {
  return Promise.reject(error);
});

export default axios;
